import { LOGIN as login } from './login';
import { REGISTER as register } from './register';

export const USER = {
  register,
  login,
  forgot_password: {},
  resetPassword: {}
};
